module.exports = __webpack_public_path__ + "img/數位專題集散地-03.838196b7.jpg";